import { useStore } from 'vuex';

import authApi from '@/modules/auth/api/authApi';
import utils from '@/utils/utils';

import { useLoading } from 'vue-loading-overlay';

const useUsuarios = () => {
    const store = useStore();
    const $loading = useLoading();

    const cabecera = () => ({
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + store.getters['auth/getToken'],
        }
    });

    const obtenerUsuarios = async (nombre: string) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/usuarios-admin/obtener-usuarios/${ nombre }`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const obtenerUsuario = async (id_usuario: number) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
            sucursales: [] as number[],
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/usuarios-admin/obtener-usuario/${ id_usuario }`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
                respuesta.sucursales = data.extraData;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const grabarUsuario = async (usuario: any) => {
        const respuesta = {
            ok: false,
            data: 0,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.post(
                '/usuarios-admin/grabar-usuario',
                usuario,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.data = data.datos;
                respuesta.ok = true;
            }
            utils.mostrarMensaje({
                descripcion: data.mensaje.descripcion,
                tipoMensaje: data.mensaje.tipoMensaje
            });
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const cambiarEstadoUsuario = async (id_usuario: number, estado: boolean) => {
        const respuesta = {
            ok: false,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.post(
                '/usuarios-admin/cambiar-estado-usuario',
                { id_usuario, estado },
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
            }
            utils.mostrarMensaje({
                descripcion: data.mensaje.descripcion,
                tipoMensaje: data.mensaje.tipoMensaje
            });
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const obtenerRolesHabilitados = async () => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/roles/obtener-roles-habilitados`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const obtenerSucursalesHabilitadas = async () => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/sucursales/obtener-sucursales-habilitadas`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    return {
        obtenerUsuarios,
        obtenerUsuario,
        grabarUsuario,
        cambiarEstadoUsuario,
        obtenerRolesHabilitados,
        obtenerSucursalesHabilitadas,
    }
};

export default useUsuarios;
